import { render, staticRenderFns } from "./GlobalChooser.vue?vue&type=template&id=48e495e4&"
import script from "./GlobalChooser.vue?vue&type=script&lang=js&"
export * from "./GlobalChooser.vue?vue&type=script&lang=js&"
import style0 from "./GlobalChooser.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports